import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from "./MapPopupStyles.js";

function ZonePopUpInfo(props){
  const { data, classes } = props;
  const { AREA_3, Name, ZIP, St} = data;
  return(
    <Paper className={`popupBGColor ${classes.zonePopUp}`}>
          <Table className={classes.table} padding="none">
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.headHeight}>
                <TableCell colSpan={2} className={classes.tableHeadCell}>         
                    <div className={classes.routeNameInfo}>Zone {AREA_3}</div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={classes.tableRowRoot}>
                <TableCell className={`${classes.labelCell} ${classes.firstTableCell} tableCellName`}>City</TableCell>
                <TableCell className={`${classes.dataCell} ${classes.firstTableCell} ${classes.popupDataStyle} tableCellValue`}>
                  {Name}
                </TableCell>
              </TableRow>
              <TableRow className={classes.tableRowRoot}>
                <TableCell className={`${classes.labelCell} tableCellName`}>State</TableCell>
                <TableCell className={`${classes.dataCell} ${classes.popupDataStyle} tableCellValue`}>
                  {St}
                </TableCell>
              </TableRow>
              <TableRow className={classes.tableRowRoot}>
                <TableCell className={`${classes.labelCell} tableCellName ${classes.lastTableCell}`}>Zip</TableCell>
                <TableCell className={`${classes.dataCell} ${classes.popupDataStyle} tableCellValue ${classes.lastTableCell}`}>
                  {ZIP}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
  );
}

export default withStyles(styles)(ZonePopUpInfo);